<p-dataView [layout]="'grid'" [value]="allegatiToShow()" [rows]="12" [paginator]="true" [alwaysShowPaginator]="false"
  [emptyMessage]="emptyMessage()" >
  @if (showHeader()) {
    <p-header>
      <div *hasClaim="GassClaims.DocModifica" class="flex justify-content-between flex-wrap gap-2">
        <div class="flex gap-2 flex-wrap">
          <button pButton type="button" icon="pi pi-plus" class="p-button-primary" [label]="addButtonLabel()" [title]="addButtonLabel()"
            (click)="openAddAllegatiDialog()" [disabled]="isLocked()">
          </button>
          @if (showScanButton() && hasRiferimenti() && isDeparture()) {
            <button pButton type="button" class="scan" label="Trasmetti/Riproduci" title="Trasmetti/Riproduci"
              (click)="riproduciAllegati.emit()" icon="fas fa-clone" [disabled]="isLocked()"></button>
          }
        </div>
        @if (showSharedFiles()) {
        <button pButton type="button" class="shared" severity="primary" (click)="toggleAllegatiCondivisi()" title="Mostra/Nascondi File condivisi"
          [icon]="mostraCondivisi() ? 'fa-solid fa-folder-open' : 'fas fa-folder'" [disabled]="isLocked()">
        </button>
        }
      </div>
    </p-header>
  }
  <ng-template let-allegati pTemplate="grid">
    <div class="grid">
      @for (allegato of allegatiToShow(); track $index) {
      <div class="col-2 file" [ngClass]="{'allegato-shared': allegato.fromSharedFolder}">
        <div class="grid">
          <div class="col-9" (click)="loadAllegato(allegato);">
            <div class="col-12" style="text-align: center;">
              <i [class]="getFileIconClass(allegato)" style="font-size: 2em;"></i>
            </div>
            <div class="col-12 filename" [title]="allegato.fileName">{{allegato.fileName}}</div>
            @if (allegato.descrizione) {
              <div class="col-12 file-description" [title]="allegato.descrizione">{{allegato.descrizione}}</div>
            }
            @if(!allegato.fromSharedFolder && showPrimaryCheckbox()){
              <div class="col-12 primario-row" (click)="$event.stopPropagation()">
                <div class="primario-checkbox">
                  <p-checkbox [binary]="true" [ngModel]="allegato.isPrimario" [disabled]="isLocked()"
                    [inputId]="'primario-' + allegato.streamId"
                    (onChange)="primaryChange($event.checked, allegato)">
                  </p-checkbox>
                  <label [for]="'primario-' + allegato.streamId" title="Allegato primario">Primario</label>
                </div>
              </div>
            }
          </div>
          <div class="col-3">
            <div class="col-12">
              @if(!allegato.fromSharedFolder){
                @if (allegato.isP7m) {
                <div (click)="downloadOriginalSigned($event, allegato)">
                  <i class="fas fa-file-signature side-icon" title="Scarica file originale (.p7m)"></i>
                </div>
                }
                <ng-container *hasClaim="GassClaims.StampaAllegati">
                  <div (click)="!allegato.hasPassword ? $event.stopPropagation() : showPasswordClick($event, allegato)"
                    [class.isDisabled]="!allegato.hasPassword">
                    <i class="fas fa-key side-icon"
                      title="{{!allegato.hasPassword ? 'Allegato non protetto' :'Visualizza password'}}"></i>
                  </div>
                </ng-container>
                @if (allegato.riproduzione) {
                <div (click)="!isLocked() ? showToggle($event,allegato,opallegato) : $event.stopPropagation()"
                  [class.isDisabled]="isLocked()">
                  <i class="fas fa-clone side-icon" title="Gestisci pagine riprodotte"></i>
                </div>
                }
                <ng-container *hasClaim="GassClaims.DocModifica">
                  @if (!isLocked()) {
                    @if (hasOCR(allegato)) {
                    <div (click)="showToggleOCR($event,allegato,opocr)">
                      <i class="fas fa-edit side-icon" title="Modifica testo OCR"></i>
                    </div>
                    }
                    @else if (isPDF(allegato)) {
                    <div (click)="relaunchOCRClick($event, allegato)">
                      <i class="fas fa-spell-check side-icon" title="Esegui riconoscimento caratteri"></i>
                    </div>
                    }
                    <div (click)="deleteClick($event, allegato)">
                      <i class="fas fa-trash side-icon" title="Elimina allegato"></i>
                    </div>
                  }
                </ng-container>
              }@else {
                <div class="upload-shared" (click)="showUploadAllegatoCondiviso(allegato)">
                  <i class="fas fa-upload side-icon" [ngClass]="updatingAllegati() ? 'isDisabled' : ''" title="Carica allegato"></i>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      }
    <!-- <app-allegati-condivisi [allegati]="allegatiCondivisi()"/> -->
    </div>
  </ng-template>
</p-dataView>

<p-dialog [header]="addDialogTitle()" [modal]="true" [visible]="showAddAllegatiDialog()" (onHide)="closeAddAllegatiDialog()"
  [style]="{'width':'32rem'}">
  <div class="flex flex-column gap-4">
    <p class="m-0">{{descriptionText()}}</p>
    <div class="flex flex-column gap-3 w-full">
      <p-fileUpload #fileUpload [name]="'file'" [multiple]="false" [fileLimit]="1" [chooseLabel]="'Carica'" [withCredentials]="true"
        [auto]="false" [showUploadButton]="false" [showCancelButton]="false" [url]="uploadUrl()" mode="advanced"
        (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove($event)" (onClear)="onFileClear()"
        (onUpload)="onUpload($event)" (onError)="onUploadError($event)" (onBeforeUpload)="onBeforeUpload($event)"
        [disabled]="isLocked() || uploadingInProgress() || scanInProgress()" class="w-full">
      </p-fileUpload>
      @if (showScanButton()) {
      <button pButton type="button" class="scan w-full" label="Scansiona" title="Scansiona" (click)="scan.emit()"
        icon="fas fa-laptop" [loading]="scanInProgress()"
        [disabled]="isLocked() || uploadingInProgress() || scanInProgress() || filesReadyForUpload().length > 0">
      </button>
      }
      <div class="flex flex-column gap-1 w-full">
        <label for="upload-description" class="text-sm font-medium">Descrizione *</label>
        <input id="upload-description" type="text" pInputText class="w-full"
          [ngModel]="uploadDescription()" (ngModelChange)="onUploadDescriptionChange($event)"
          (blur)="markUploadDescriptionTouched()" [disabled]="isLocked() || uploadingInProgress()">
        @if (isUploadDescriptionInvalid()) {
          <small class="p-error">Campo obbligatorio</small>
        }
      </div>
    </div>
    @if (filesReadyForUpload().length === 0) {
      <small class="text-color-secondary">Nessun file in coda: seleziona uno o più documenti per abilitarne l'invio.</small>
    } @else {
      <small class="text-color-secondary">{{filesReadyForUpload().length}} file pronti al caricamento.</small>
    }
  </div>
  <p-footer>
    <div class="flex justify-content-end gap-2 flex-wrap">
      <button pButton type="button" icon="pi pi-times" label="Annulla" title="Chiudi modale" class="p-button-secondary"
        (click)="closeAddAllegatiDialog()" [disabled]="uploadingInProgress()"></button>
      <button pButton type="button" icon="pi pi-check" label="Salva" title="Carica gli allegati selezionati"
        (click)="confirmUpload()"
        [disabled]="isConfirmUploadDisabled()">
      </button>
    </div>
  </p-footer>
</p-dialog>

<p-overlayPanel #opallegato [dismissable]="true" [showCloseIcon]="true" [appendTo]="'body'" styleClass="pages-chips">
  @if (selectedAllegato) {
  <div class="grid" style="width:500px;margin-bottom:10px">
    <div class="col-12">
      <p-radioButton name="groupname" [value]="true" [(ngModel)]="riproduciTutto"
        label="Tutto il documento"></p-radioButton>
    </div>
    <div class="col-12">
      <p-radioButton name="groupname" [value]="false" [(ngModel)]="riproduciTutto"
        label="Le seguenti pagine (o intervalli), es: 1, 2-5"></p-radioButton>
    </div>
  </div>
  <div class="panel-section">
    <p-chips [(ngModel)]="reproPages" separator="," (onAdd)="validateInput($event)"
      [disabled]="riproduciTutto"></p-chips>
  </div>
  <div class="error-message">
    {{reproErrorMessage}}
  </div>
  <p-footer>
    <div style="text-align:right;">
      <button pButton type="button" icon="pi pi-times" label="Annulla" title="Annulla"
        (click)="undoClick($event, opallegato)" class="p-button-secondary" style="margin-right: 10px;"></button>
      <button pButton type="button" class="p-button-primary" style="margin-right: 10px;" icon="fas fa-fw fa-registered"
        label="Conferma" title="Conferma" (click)="changeReproClick($event, selectedAllegato, opallegato)">
      </button>
    </div>
  </p-footer>
  }
  @else {
  <p-footer>
    <div style="text-align:right;">
      <button pButton type="button" icon="pi pi-times" label="Annulla" title="Annulla"
        (click)="undoClick($event, opallegato)" class="p-button-secondary" style="margin-right: 10px;"></button>
    </div>
  </p-footer>
  }
</p-overlayPanel>

<p-overlayPanel #opocr [dismissable]="true" [showCloseIcon]="true" [appendTo]="'body'" styleClass="pages-chips">
  @if (selectedAllegato) {
  <div class="grid" style="width:500px;margin-bottom:10px">
    <div style="width:100%">
      <label for="ocrtesto">Testo contenuto nell'allegato</label>
      <textarea id="ocrtesto" class="ocr-testo" pInputTextarea [(ngModel)]="selectedAllegato.ocrTesto"
        title="Note"></textarea>
    </div>
  </div>
  <p-footer>
    <div class="grid">
      <div class="col6">
        <button pButton type="button" icon="fas fa-spell-check" label="Avvia riconoscimento caratteri"
          title="Avvia riconoscimento caratteri" (click)="relaunchOCRandCloseClick($event, selectedAllegato, opocr)"
          class="p-button-primary">
        </button>
      </div>
      <div class="col6" style="margin-left: auto; margin-right: 0;">
        <button pButton type="button" icon="pi pi-times" label="Annulla" title="Annulla"
          (click)="undoOCRClick($event, opocr)" class="p-button-secondary" style="margin-right: 10px;">
        </button>
        <button pButton type="button" class="p-button-primary" style="margin-right: 10px;" icon="fas fa-fw fa-check"
          label="Conferma" title="Conferma" (click)="changeOCRClick($event, selectedAllegato, opocr)">
        </button>
      </div>
    </div>
  </p-footer>
  }
  @else {
  <p-footer>
    <div style="text-align:right;">
      <button pButton type="button" icon="pi pi-times" label="Annulla" title="Annulla"
        (click)="undoOCRClick($event, opocr)" class="p-button-secondary" style="margin-right: 10px;">
      </button>
    </div>
  </p-footer>
  }
</p-overlayPanel>
